import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useAmplitude, useTrackOnMount } from '../../providers/AmplitudeProvider';
import { AmplitudeEvent } from '../../constants/amplitudeEvents';

interface SocialProofProps {
    ageGroup: string;
    onContinue: () => void;
    onBack: () => void;
}

const getAgeText = (ageGroup: string): string => {
    switch (ageGroup) {
        case '18-29':
            return '20s';
        case '30-39':
            return '30s';
        case '40-49':
            return '40s';
        case '50+':
            return '50s';
        default:
            return '50s';
    }
};

const SocialProof: React.FC<SocialProofProps> = ({ ageGroup, onContinue, onBack }) => {
    const ageText = getAgeText(ageGroup);
    const { trackEvent } = useAmplitude();

    useTrackOnMount([
        { event: AmplitudeEvent.QUESTION_VIEWED, properties: { step_number: 2, screen_name: 'social_proof_milestone' } },
    ]);

    const handleContinue = () => {
        // trackEvent('onboarding_step_viewed', {
        //     step_number: 2,
        //     screen_name: 'social_proof_milestone',
        //     milestone: '2_million_women',
        // });
        trackEvent(AmplitudeEvent.QUESTION_ANSWERED, {
            step_number: 2,
            screen_name: 'social_proof_milestone',
            milestone: '2_million_women',
        });
        onContinue();
    };

    return (
        <div className="min-h-screen bg-white flex flex-col">
            <header className="flex items-center px-4 py-[26px] border-b border-[#17171714]">
                <button
                    onClick={onBack}
                    className="w-10 h-10 flex items-center justify-center rounded-full border border-[#00000066]"
                >
                    <ArrowLeft className="w-5 h-5" />
                </button>
                <div className="flex-1 flex justify-center mr-10">
                    <span className="font-poppins text-[24px] tracking-[-2px]">
                        Move <span className="font-semibold">Together</span>
                    </span>
                </div>
            </header>

            <div className="flex-1 max-w-lg lg:mx-auto flex flex-col px-6 pt-10">
                <div className="mb-8">
                    <h1 className="font-poppins text-[36px]/[43.2px] font-semibold text-[#369FFF]">
                        Over 2 million<br />women
                    </h1>
                    <p className="text-[20px] text-[#4A4A4A]">
                        in <span className="font-bold text-black">their {ageText}</span> have already tried<br />
                        Move Together
                    </p>
                </div>

                <img
                    src="https://funnel-cdn.b-cdn.net/images/social-proof-women.png"
                    alt="Women who use Move Together"
                    className="max-w-full h-auto"
                    loading="lazy"
                    decoding="async"
                    onError={(e) => {
                        e.currentTarget.style.display = 'none';
                    }}
                />
            </div>

            <div className="px-5 py-6 border-t border-[#F0F0F0] bg-white">
                <div className="max-w-md mx-auto">
                    <button
                        onClick={handleContinue}
                        className="w-full bg-[#369FFF] text-white py-4 rounded-full font-semibold text-[16px] uppercase tracking-wider hover:bg-blue-600 transition-colors"
                    >
                        Continue
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SocialProof;
